/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const FlowOptions = {
  VALIDATE_DOCUMENTS_TO_SIGN: 'ValidateDocumentsToSign',
  LOGIN: 'Login',
  EXTERNAL_COMPANY: 'ExternalCompany',
  ACTIVATION: 'Activation'
}

export const EventTypes = {
  CLOSE_IFRAME: 'closeIframe',
  SHOW_PORTAL: 'showPortal',
  REDIRECT: 'redirect',
  CLOSE_SESSION: 'closeSession',
}

export const LayoutBreakpoints = {
  SMALL: 768,
  SMALL_LANDSCAPE: 500,
  DESKTOP: 1025,
}
